const locale = {
  "Rain and Lightning map": "Rain and Lightning map",
  "Today's weather": "Today's weather",
};

export default locale;
